export default __webpack_public_path__ + "static/media/travelLog.e4fc6078.jpg";